import { Platform, ResourceType } from '../../../../../models/api';

// Unsupported resource types for resource-triggered playbooks (more restrictive)
export const unsupportedResourceTypesByPlatform: {
  [platform in Platform]?: ResourceType[];
} = {
  [Platform.powerplatform]: [
    ResourceType.user,
    ResourceType.azure_active_directory_group,
    ResourceType.connection,
    ResourceType.gateway,
    ResourceType.gateway_cluster,
    ResourceType.virtual_connector,
  ],
  [Platform.powerBI]: [
    ResourceType.user,
    ResourceType.azure_active_directory_group,
    ResourceType.app,
    ResourceType.workspace,
    ResourceType.dashboard,
    ResourceType.datasource,
    ResourceType.lakehouse,
    ResourceType.ai_skill,
    ResourceType.warehouse,
  ],
  [Platform.budibase]: [],
  [Platform.airtable]: [],
};

export const unsupportedAllResourceTypes = [
  ResourceType.user,
  ResourceType.azure_active_directory_group,
  ResourceType.connection,
  ResourceType.gateway,
  ResourceType.gateway_cluster,
  ResourceType.virtual_connector,
  ResourceType.app,
  ResourceType.workspace,
  ResourceType.dashboard,
  ResourceType.datasource,
  ResourceType.warehouse,
];

// Unsupported resource types for violation-triggered playbooks (less restrictive)
// Workspace and dashboard are supported for violation triggers
export const unsupportedResourceTypesForViolationByPlatform: {
  [platform in Platform]?: ResourceType[];
} = {
  [Platform.powerplatform]: [
    ResourceType.user,
    ResourceType.azure_active_directory_group,
    ResourceType.connection,
    ResourceType.gateway,
    ResourceType.gateway_cluster,
    ResourceType.virtual_connector,
  ],
  [Platform.powerBI]: [
    ResourceType.user,
    ResourceType.azure_active_directory_group,
    ResourceType.app,
    ResourceType.datasource,
    ResourceType.lakehouse,
    ResourceType.ai_skill,
    ResourceType.warehouse,
  ],
  [Platform.budibase]: [],
  [Platform.airtable]: [],
};

export const unsupportedAllResourceTypesForViolation = [
  ResourceType.user,
  ResourceType.azure_active_directory_group,
  ResourceType.connection,
  ResourceType.gateway,
  ResourceType.gateway_cluster,
  ResourceType.virtual_connector,
  ResourceType.app,
  ResourceType.datasource,
  ResourceType.warehouse,
];
